import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { printOwner } from '../Api'

export default generateApiAction({
  baseType: Types.PRINT.OWNER,
  api: printOwner,
  responseType: RESPONSETYPE.FILE
})



// WEBPACK FOOTER //
// ./src/actions/print/PrintOwnerAction.js